import { useState, useEffect, useRef } from 'react';

export default function useComponentVisible(IsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState();
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        setIsComponentVisible(IsVisible);
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [IsVisible]);

    return { ref, isComponentVisible, setIsComponentVisible };
}